export default __webpack_public_path__ + "static/media/twitter-pfp-modified.733e9bfe.png";